import { render, staticRenderFns } from "./merchant-order-settlement.vue?vue&type=template&id=cbd3e638&scoped=true"
import script from "./merchant-order-settlement.vue?vue&type=script&lang=js"
export * from "./merchant-order-settlement.vue?vue&type=script&lang=js"
import style0 from "./merchant-order-settlement.vue?vue&type=style&index=0&id=cbd3e638&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbd3e638",
  null
  
)

export default component.exports